import type { ReminderServiceSettings, ReminderSettings } from '@/types/organizations';

export const DEFAULT_REMINDER_SETTINGS: ReminderSettings = {
  inspection: { enabled: false, notify: false },
  tax: { enabled: false, notify: false },
};

function parseService(raw: unknown): ReminderServiceSettings {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_REMINDER_SETTINGS.inspection };
  const row = raw as { enabled?: unknown; notify?: unknown };
  const enabled = row.enabled === true;
  return { enabled, notify: enabled && row.notify === true };
}

export function mergeReminderOrgSettings(raw?: ReminderSettings | string | null): ReminderSettings {
  let v: unknown = raw ?? null;
  if (typeof raw === 'string') {
    try {
      v = JSON.parse(raw);
    } catch {
      return { ...DEFAULT_REMINDER_SETTINGS };
    }
  }
  if (!v || typeof v !== 'object') return { ...DEFAULT_REMINDER_SETTINGS };
  const obj = v as { inspection?: unknown; tax?: unknown };
  return {
    inspection: parseService(obj.inspection),
    tax: parseService(obj.tax),
  };
}
